export const degreesCleaner = (degrees: string): string => {
  return degrees?.replace(/[a-zA-Z]+/, '') || ''
}